import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TopicCategory } from "../topicCategory/entities/TopicCategory";

// Définition du store avec persistance dans localStorage
interface TopicCategoryStore {
  topicCategories: TopicCategory[];
  setTopicCategories: (topicCategories: TopicCategory[]) => void;
}

export const useTopicCategoriesStore = create<TopicCategoryStore>()(
  persist(
    (set) => ({
      topicCategories: [],
      setTopicCategories: (topicCategories) => set({ topicCategories }),
    }),
    {
      name: "topicCategories-storage", // Clé dans le localStorage
    }
  )
);
